.wrapper {
  width: 400px;
  margin: 40px 100px;
}

.formWrapper {
  margin-top: 20px;
}

.orLink {
  margin-left: 20px;
}
